export default {
    description: "Leírás",
    orderingNote: "Rendelési megjegyzés"
}